<template>
  <div>
    <b-card class="create-form container" :header="pageTitle" header-tag="h3">
      <form v-if="formLoaded">
        <vue-form-generator :class="$route.name" :schema="schema" :model="model"
                            :options="getFormOptions()"
        />
      </form>

      <div v-else>
        {{ $t('_loading') }}
      </div>
    </b-card>
  </div>
</template>

<script>
import VueFormGenerator from 'vue-form-generator'
import 'vue-form-generator/dist/vfg.css'
import Pikaday from 'pikaday'
import 'pikaday/css/pikaday.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import Cleave from 'cleave.js'
import phoneFormatter from 'cleave.js/dist/addons/cleave-phone.fr'
import AbstractApi from '@/api/abstractApi'
import {isHotel} from "@/utils/auth";

// TODO: voir comment charger Pikaday et Cleave correctement (webpack ? module.exports ?)
if (typeof window !== 'undefined') {
  window.Pikaday = Pikaday
  window.cleave = Cleave
}

export default {
  components: {
    'vue-form-generator': VueFormGenerator.component
  },

  props: {
    entityName: {
      type: String,
      required: true
    },
    id: {
      Type: [ String, Number ]
    }
  },

  data: () => {
    return {
      apiObject: undefined,
      apiForm: {},
      formLoaded: false,
      formValid: false,
      model: {}, // Populated in created event
      schema: {}, // Populated in created event
      formOptions: {
        validateAfterLoad: true,
        validateAfterChanged: false
      },
      pageTitle: 'Modification'
    }
  },

  created: function () {
    this.apiObject = new AbstractApi(this.entityName, this.id)
    let parentEntity = this.$route.params.parentEntity
    let parentId = this.$route.params.id
    this.apiObject.loadForm(parentId).then(response => (
      this.loadApiForm(this.apiObject.parseApiObject(response))
    )).then(response => {
      // Pass parentId to create form
      let regex = new RegExp('_create$')

      if (regex.test(this.$route.name) && parentEntity && parentId)
        this.model[parentEntity] = { id: parentId }
    })
  },

  methods: {
    loadApiForm: function (apiForm) {
      // if form was submitted and valid, redirect user
      if (apiForm.isSubmitted && apiForm.isValid) {
        if (apiForm.redirect) {
          this.$router.push(apiForm.redirect)
        } else {
          let entityName = this.apiObject.getEntityName()
          let entityId = apiForm.value.id
          if (entityId) {
            this.$router.push({ name: entityName + '_show', params: { id: entityId } })
          } else {
            this.$router.push({ name: entityName + '_list' })
          }
        }
      }

      // Load model before instanciate the component
      this.model = this.apiObject.getModelFromApiForm(apiForm)
      this.apiForm = apiForm

      // load schema from api response
      this.schema = this.apiObject.createSchemaFromApiForm(
        this.apiForm,
        this.submitForm,
        this.goBack,
        !!this.id
      )

      // set title
      let titleField = this.apiObject.getTitleField()
      if ( this.id ) {
        this.pageTitle = this.$i18n.t(this.apiObject.getEntityName() + '.edit.page_title')

        if (this.model[titleField]) this.pageTitle  += ` ${this.model[titleField]}`
      } else {
        this.pageTitle = this.$i18n.t(this.apiObject.getEntityName() + '.create.page_title')
      }

      // This will instanciate the form component, built with model and form loaded from api
      this.formLoaded = true
    },

    getFormOptions: function () {
      return this.formOptions
    },

    submitForm: function () {
      this.apiObject.submitForm(this.model).then(response => (
        this.loadApiForm(this.apiObject.parseApiObject(response))
      ))
    },

    goBack () {
      if (isHotel()) {
        // Retour au menu principal comme un hotel n'a pas de sous-menu
        this.$router.push({path: '/'})
      } else {
        let route = {
          name: `${this.entityName}_${this.id ? 'show' : 'list'}`
        }

        if (this.id) route.params = {id: this.$route.params.id}

        this.$router.push(route)
      }
    }
  }
}
</script>
